import { Factory } from 'fishery';
import {
  InspectionGetNotesResult,
  InspectionSearchResponse,
  InspectionSearchResult,
} from './InspectionService.types';

export const inspectionSearchResultFactory = Factory.define<InspectionSearchResult>(
  ({ sequence }) => {
    return {
      commodityId: '0feb2e83-947c-41a9-81a7-2dbbbc8ecb22',
      dateCreated: '2023-01-20T22:32:24.981Z',
      id: sequence.toString(),
      jobId: '8075cb47-aba0-47d3-bc46-3433d60ba73a',
      orderId: 'dee70bdc-ee59-47a0-9f0a-82f86f390343',
      status: 'completed',
      stopId: 'fa6ee2cd-c9b7-49c6-95de-5dfffdf57ef0',
    };
  },
);

export const inspectionSearchResponseFactory = Factory.define<InspectionSearchResponse>(() => ({
  page: 1,
  rows: 2,
  total: 2,
  results: inspectionSearchResultFactory.buildList(2),
}));

export const inspectionGetNotesResultFactory = Factory.define<InspectionGetNotesResult>(
  ({ sequence }) => ({
    id: sequence.toString(),
    title: 'Note title',
    body: 'This is the note',
    type: '',
    dateCreated: '2023-11-02T06:09:03.300-07:00',
    createdById: '56891515-c4e4-4e31-9634-97e77e91d8f0',
  }),
);
